import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

export const dirRtl = true;
// Create rtl cache
const cacheRtl = createCache({
	key: 'muirtl',
	stylisPlugins: [rtlPlugin],
} );

const CacheProviderRtl  = ({ children })  => {
	return dirRtl ? (
		<CacheProvider value={cacheRtl}>
			<div dir="rtl" className="muiRTL">
				{children}
			</div>
		</CacheProvider>
	) : (
		<>{children}</>
	);
};

export default CacheProviderRtl;
